/**
 * Last-sync footer (feature #6). Reads app_config/global.syncHealth for the
 * category in view and shows when it last synced. Also surfaces an offline /
 * stale banner when the device is offline.
 */
import { useAppConfig } from '../../hooks/useAppConfig';
import { relativeTime } from '../../lib/format';

export function SyncFooter({ category }: { category: string | null }): JSX.Element | null {
  const config = useAppConfig();
  if (!config) return null;

  const entry = category ? config.syncHealth?.[category] : undefined;
  const lastSyncAt = entry?.lastSyncAt ?? config.updatedAt;
  if (!lastSyncAt) return null;

  const status = entry?.lastStatus;
  const tone =
    status === 'error' ? 'text-red-500' : status === 'partial' ? 'text-stale' : 'text-slate-400';

  return (
    <footer className={`border-t border-slate-100 bg-white px-4 py-1.5 text-center text-[11px] ${tone}`}>
      Prices last synced {relativeTime(lastSyncAt)}
      {status && status !== 'ok' ? ` · sync ${status}` : ''}
    </footer>
  );
}
